import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const RulesOfInference = () => (
  <DMModuleSubtopic
    title="Rules of inference"
    videos={[
      "https://www.youtube.com/embed/udp92HTtVLc",
      "https://www.youtube.com/embed/lGVTIafQvQs",
      "https://www.youtube.com/embed/EIkKp-uz8ZU"
    ]}
    takeaways={[
        {image:"/dm_1.png"},
        {image:"/dm_2.png"},
        {image:"/dm_3.png"},
        {image:"/dm_4.png"}
    ]}
    questions={[
      { text: 'Construct an argument to show that the following premises imply the conclusion "it rained". (i) If it does not rain or if there is no traffic dislocation, then the sports day will be held and the cultural programme will go on. (ii) If the sports day is held then the trophy will be awarded. (iii) The trophy was not awarded.' },
      { text: 'Show that the premises "A student in this class has not read the book" and "Everyone in this class passed the first exam" imply the conclusion "Someone who passed the first exam has not read the book."' },
      { text: 'Show that the following statements are inconsistent: (i) If Jack gets his UG degree, then he will go for a job (ii) If Jack goes for a job, then he will get married soon (iii) If Jack goes for higher study, then he will not get married (iv) Jack gets his higher degree and goes for higher study.' },
      { text: "Prove that the following premises are inconsistent: P→Q , P→R , Q→R' , P" },
      { text: 'Show that the following premises are inconsistent (i) If Raja misses many classes through illness, then he fails high school (ii) If Raja fails high school, then he is uneducated (iii) If Raja reads a lot of books, then he is not uneducated (iv) Raja misses many classes through illness and reads a lot of books.' }
    ]}
    exampleVideos={[]}
  />
);

export default RulesOfInference;
